import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Inject custom CSS from API (fetched in index.html) BEFORE React mounts to avoid flash
const injectCustomCSS = () => {
  if (window.__customCssData && !document.getElementById("custom-css-from-api")) {
    const style = document.createElement("style");
    style.id = "custom-css-from-api";
    style.textContent = window.__customCssData;
    document.head.appendChild(style);
  }
};

// Inject before React renders to prevent FOUC
injectCustomCSS();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
